var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0576 0.800293C19.7867 0.800293 25.3162 5.94092 25.3164 12.3882C25.3164 15.0864 24.3248 17.5763 22.6689 19.5376C20.4939 22.1879 17.0895 23.8879 13.2832 23.9526L8.03125 27.0962L8.03027 27.0952C6.51445 28.0214 4.6697 26.7299 4.86719 25.0366L4.86816 25.0288L5.33008 21.3608C2.56727 19.2575 0.799805 16.0257 0.799805 12.3882C0.799937 8.39979 2.9158 4.90308 6.125 2.8374C8.10897 1.53648 10.4885 0.800355 13.0576 0.800293Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.72f84fd111325d9cefb56d878c1a5e55.svg";
export { ForwardRef as ReactComponent };